// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  PUBLIC_CONFIG: `${API_BASE_URL}/api/accounts/public-config/`,
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/accounts/auth/login/`,
    REGISTER: `${API_BASE_URL}/api/accounts/auth/register/`,
    VERIFY_EMAIL: `${API_BASE_URL}/api/accounts/auth/verify-email/`,
    RESEND_VERIFICATION: `${API_BASE_URL}/api/accounts/auth/resend-verification/`,
    LOGOUT: `${API_BASE_URL}/api/accounts/auth/logout/`,
    DELETE_ACCOUNT: `${API_BASE_URL}/api/accounts/delete-account/`,
    REFRESH: `${API_BASE_URL}/api/accounts/auth/token/refresh/`,
    USER_INFO: `${API_BASE_URL}/api/accounts/user-info/`,
    PROFILE: `${API_BASE_URL}/api/accounts/profile/`,
    CHANGE_PASSWORD: `${API_BASE_URL}/api/accounts/password/change/`,
    FORGOT_PASSWORD: `${API_BASE_URL}/api/accounts/password/reset/`,
    AVATARS: `${API_BASE_URL}/api/accounts/avatars/`,
    PROVIDER_INVITE_PREVIEW: `${API_BASE_URL}/api/accounts/provider-invite/preview/`,
    PROVIDER_INVITE_REDEEM: `${API_BASE_URL}/api/accounts/provider-invite/redeem/`,
    PROVIDER_MEMBERSHIP_LEAVE: `${API_BASE_URL}/api/accounts/provider-membership/leave/`,
    PROVIDER_TERMS_ACCEPT: `${API_BASE_URL}/api/accounts/provider-terms/accept/`,
  },
  CONVERSATIONS: {
    LIST: `${API_BASE_URL}/api/conversations/conversations/`,
    MESSAGES: (conversationId: string) => `${API_BASE_URL}/api/conversations/messages/?conversation=${conversationId}`,
    SEND_MESSAGE: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/send-message/`,
    DETAIL: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/`,
    EVENTS: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/events/`,
    CLOSE: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/close_conversation/`,
    ARCHIVE: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/archive/`,
    PIN: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/pin/`,
    UNPIN: (conversationId: string) => `${API_BASE_URL}/api/conversations/conversations/${conversationId}/unpin/`,
  },
  CONTENT: {
    ITEMS: `${API_BASE_URL}/api/content/items/`,
    DETAIL: (contentId: string) => `${API_BASE_URL}/api/content/items/${contentId}/`,
    PIN: (contentId: string) => `${API_BASE_URL}/api/content/items/${contentId}/pin/`,
    UNPIN: (contentId: string) => `${API_BASE_URL}/api/content/items/${contentId}/unpin/`,
    CATEGORIES: `${API_BASE_URL}/api/content/categories/`,
  },
  HABITS: {
    LIST: `${API_BASE_URL}/api/habits/habits/`,
    DETAIL: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/`,
    ACTIVATE: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/activate/`,
    PAUSE: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/pause/`,
    DISMISS: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/dismiss/`,
    COMPLETE: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/complete/`,
    DISCUSS: (habitId: string) => `${API_BASE_URL}/api/habits/habits/${habitId}/discuss/`,
    ACTION_CHECKIN: (actionId: string) => `${API_BASE_URL}/api/habits/actions/${actionId}/checkin/`,
    HOME_STATS: `${API_BASE_URL}/api/habits/habits/home_stats/`,
    TODAYS_FOCUS: `${API_BASE_URL}/api/habits/habits/todays_focus/`,
  },
  GOOD_TO_GO: {
    STATUS: `${API_BASE_URL}/api/good-to-go/status/`,
    SUBMISSIONS: `${API_BASE_URL}/api/good-to-go/submissions/`,
    HISTORY: `${API_BASE_URL}/api/good-to-go/history/`,
  },
};

export default API_ENDPOINTS;
